import React from "react";
import "./UpdateTime.css";

function UpdateTime({ time }) {
  return <div className="time center">Last updated: {time}</div>;
}

export default UpdateTime;
